import { useRef, useState } from "react";
import { Eraser, Loader2, PenLine } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError, uploadImage } from "@/lib/api";
import { SignaturePad } from "@/components/SignaturePad";

function Pad({ title, padRef, onInk, testid }) {
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex justify-between items-center">
        <p className="eyebrow">{title}</p>
        <button type="button" onClick={() => padRef.current.clear()} className="btn-ghost h-8 px-3 text-xs" data-testid={`${testid}-clear`}><Eraser className="h-4 w-4" /> Cancella</button>
      </div>
      <SignaturePad ref={padRef} onChange={onInk} />
    </div>
  );
}

export function ImpSign({ imp, conditions, onSigned }) {
  const [name, setName] = useState(imp.versions[imp.versions.length - 1].data.customer.name);
  const [inkC, setInkC] = useState(false);
  const [inkS, setInkS] = useState(false);
  const [busy, setBusy] = useState(false);
  const cRef = useRef(null);
  const sRef = useRef(null);

  const submit = async () => {
    setBusy(true);
    try {
      const c = await uploadImage(await cRef.current.toBlob(), "firma_cliente.png");
      const s = await uploadImage(await sRef.current.toBlob(), "firma_incaricato.png");
      const { data } = await api.post(`/impegnative/${imp.id}/sign`, { client_name: name.trim(), client_signature_path: c, staff_signature_path: s });
      toast.success("Impegnativa firmata");
      onSigned(data);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="rounded-2xl bg-white border-2 border-[var(--primary)] p-4 sm:p-5 space-y-5" data-testid="imp-sign-section">
      <h2 className="font-heading text-lg font-semibold flex items-center gap-2"><PenLine className="h-5 w-5 text-[var(--primary)]" /> Firme digitali</h2>
      <div className="space-y-1.5"><p className="eyebrow">Condizioni commerciali</p><div className="max-h-40 overflow-y-auto rounded-xl bg-[var(--surface-2)] p-4 text-sm whitespace-pre-line" data-testid="imp-sign-conditions">{conditions}</div></div>
      <div className="space-y-1.5"><Label>Nome e cognome del cliente firmatario</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="imp-signer-name-input" /></div>
      <div className="grid lg:grid-cols-2 gap-5">
        <Pad title="Firma del cliente" padRef={cRef} onInk={setInkC} testid="imp-client-pad" />
        <Pad title="Firma dell'incaricato SUK" padRef={sRef} onInk={setInkS} testid="imp-staff-pad" />
      </div>
      <button onClick={submit} disabled={!name.trim() || !inkC || !inkS || busy} className="btn-primary w-full h-12" data-testid="imp-confirm-sign-button">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Conferma e firma impegnativa"}
      </button>
    </section>
  );
}
